const config = {
    // liveUrl: "https://jade-rich-catfish.cyclic.app/api"
    liveUrl: "http://localhost:5000/api"
}

export {config}